import { render, staticRenderFns } from "./alliance-introduce.vue?vue&type=template&id=fe181716&scoped=true&"
import script from "./alliance-introduce.vue?vue&type=script&lang=js&"
export * from "./alliance-introduce.vue?vue&type=script&lang=js&"
import style0 from "./alliance-introduce.vue?vue&type=style&index=0&id=fe181716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe181716",
  null
  
)

export default component.exports